<div class="bg-light border-bottom ">
  <div class="container-fluid clearfix p-2">
    <div class="float-md-right float-sm-right float-xs-right top-nav-btn res-fixed-x-space">
      <div class="d-inline-block mx-1 py-2">
        <button type="button" class="px-3 btn btn-sm text-left btn-block d-sm-block btn-outline-light-gray  font-weight-bold"><i class="ti ti-export"></i> Export</button>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid py-3 px-4 left-menu-space" id="divMainContainer">
  <div class="page-title-box d-sm-flex align-items-center justify-content-between  pb-4">
    <h4 class="mb-0 f-bold-dubai text-secondary">Meeting Actions Points</h4>
  </div>

  <h5 class="text-secondary"><b>{{type}}</b></h5>
  <div class="bg-white p-4 text-center text-muted rounded mb-3" *ngIf="isLoader">
    <div class="loader-bg"></div>
  </div>
  <div class="card rounded pt-2 h-100" *ngIf="meetingActionList==null ||meetingActionList.length<=0 && !isLoader">
    <div class="pt-2 px-3 pb-3 border-bottom text-center">
      <!--<img src="{{noDataImage}}" class="img-fluid" alt="No Data" />-->
      <h5 class="pb-4 pt-2 text-center text-secondary">No Data Available</h5>
    </div>
  </div>
  <div class="card rounded pt-2 h-100 pageloadcontainer" *ngFor="let todayItem of meetingActionList">
    <div class="pt-2 px-3 pb-3 border-bottom-0">
      <h6 class="card-title d-inline f-bold-dubai">{{todayItem.subjectAtd}}</h6>
      <div class="card-controls float-right">
        <ul class="list-inline list-badge hide-arrow-drop">
          <li class="list-inline-item">
            <a data-toggle="refresh" class="card-refresh text-black text-danger"><i class="la la-info-circle fa-lg mx-1"></i></a>
          </li>
        
          <li *ngIf="todayItem.progress ==0 || todayItem.progress ==1" class="list-inline-item nav-item" ngbDropdown>
            <a class="nav-link p-0" id="dropdownBasic1" ngbDropdownToggle><i class="la la-ellipsis-v fa-lg"></i></a>
            <ul ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <!--<li (click)="ResolveConfirm(weekItem,0)"><a ngbDropdownItem>Not Started</a></li>-->
              <li (click)="ResolveConfirm(todayItem,1)"><a ngbDropdownItem>In Progress</a></li>
              <li (click)="ResolveConfirm(todayItem,2)"><a ngbDropdownItem>Completed</a></li>
              <li (click)="ResolveConfirm(todayItem,3)"><a ngbDropdownItem>Waiting on others</a></li>
              <li (click)="ResolveConfirm(todayItem,4)"><a ngbDropdownItem>Deferred</a></li>


            </ul>
          </li>
        </ul>
      </div>
      <div class="text-secondary py-1"><p [innerHTML]="todayItem.note"></p></div>
      <div class="p-0 sm-small-size">
        <span class="pr-2"><i class="la la-calendar-o fa-lg"></i>{{todayItem.dueDate}}</span> |  <span class="px-2"><i class="la la-map-marker fa-lg"></i> {{todayItem.location !=''?todayItem.location:'NA'}}</span> | <span class="px-2"><b class="text-secondary pr-2">Initiator:</b>{{todayItem.userName}} </span>
        | <span class="px-2"><b class="text-secondary pr-2">Status:</b><span *ngIf="todayItem.progress ==0">Not Started</span><span *ngIf="todayItem.progress ==1">In Progress</span><span *ngIf="todayItem.progress ==2">Completed</span><span *ngIf="todayItem.progress ==3">Waiting on others</span><span *ngIf="todayItem.progress ==4">Deferred</span> </span>
      </div>
    </div>
  </div>
</div>
